import {
  Button,
  Box,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Input,
  InputGroup,
  InputLeftElement,
  useDisclosure,
  Tag,
  Flex,
} from "@chakra-ui/react";
import { AiOutlineSearch } from "react-icons/ai";
import { BiFilter } from "react-icons/bi";
import TableContents from "components/BasicTable";
import Paginator from "components/Paginator";
import ComposerModal from "components/ComposerModal";
import AddComposerModal from "components/AddComposerModal";
import { ImCheckmark } from "react-icons/im";
import { GiCancel } from "react-icons/gi";
import { useEffect, useState } from "react";
import { useQueryWrapper } from "services/apiHelper";
import { scriptsRequest } from "services/request";
import { QUERY_KEYS, type ScriptType, statusOBJ } from "utils/constants";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { PROTECTED_PATHS } from "routes/pagePath";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaEye, FaPencilAlt } from "react-icons/fa";
import VerifyModal from "components/VerificationPage/VerifyModal";
import { editScript } from "lib/redux/scripts/action";
import { CgAsterisk } from "react-icons/cg";
import { successToast, errorToast } from "utils/hooks";

type FilterType = "All" | "Pending" | "Published" | "Cancelled";

const VerificationPage = () => {
  const { APPROVED, PENDING, REJECTED } = statusOBJ;
  const history = useNavigate();
  const [currentScript, setCurrentScript] = useState<any>();
  const [isApproved, setIsApproved] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchParams, setSearchParam] = useSearchParams();
  const dispatch = useDispatch();
  const {
    isOpen: isOpenComposer,
    onOpen: onOpenComposer,
    onClose: onCloseComposer,
  } = useDisclosure();
  const {
    isOpen: isOpenAddComposer,
    onOpen: onOpenAddComposer,
    onClose: onCloseAddComposer,
  } = useDisclosure();
  const [newComposer, setNewComposer] = useState("");
  const COLUMNS = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Composer",
      accessor: "composer",
      Cell: function uploaded({ cell }: any) {
        const composer = cell.row.original.scriptComposer?.name;
        const suggestedComposer = cell.row.original.composer;
        return (
          <>
            {composer ? (
              <div>{composer}</div>
            ) : (
              <Flex>
                {suggestedComposer}
                <div style={{ color: "red" }}>
                  <CgAsterisk />
                </div>
                <Button
                  onClick={() => {
                    setNewComposer(suggestedComposer);
                    void copyToClipboard(suggestedComposer);
                    onOpenAddComposer();
                  }}
                >
                  Add
                </Button>
              </Flex>
            )}
          </>
        );
      },
    },
    {
      Header: "Uploaded By",
      accessor: "user.userName",
    },
    {
      Header: "Published",
      Cell: function verified({ cell }: any) {
        const status = cell.row.original.isVerified;
        return (
          <Tag
            borderRadius="full"
            bg={status === APPROVED ? "#BBE5B3" : status === REJECTED ? "orangered" : "#FFEA8A"}
            color="#414F3E"
            fontSize="xs"
            textTransform="capitalize"
          >
            {status === APPROVED ? APPROVED : status === REJECTED ? REJECTED : PENDING}
          </Tag>
        );
      },
    },
    {
      Header: "Uploaded On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },

    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Edit",
      Cell: function edit({ cell }) {
        return (
          <Button
            onClick={() => {
              dispatch(editScript(cell.row.original));
              history(`${PROTECTED_PATHS.NEW_EDIT_SCRIPT}?edit=${cell.row.original.slug}`);
            }}
          >
            <FaPencilAlt />
          </Button>
        );
      },
    },

    {
      Header: "Approve",
      Cell: ({ cell }) => (
        <Button
          isDisabled={cell.row.original.isVerified !== "Pending"}
          bg="green"
          onClick={() => {
            setCurrentScript(cell.row.original);
            if (!cell.row.original.composerId) {
              onOpenComposer();
              return;
            }
            setIsApproved(true);
            onOpen();
          }}
        >
          <ImCheckmark />
        </Button>
      ),
    },
    {
      Header: "View",
      Cell: ({ cell }: any) => (
        <Button
          variant="secondary"
          onClick={() => {
            const origin = window.location.origin;
            const page = `/scripts/${cell.row.original.slug}`;
            const url = origin + page;
            window.open(url, "_blank");
          }}
        >
          <FaEye />
        </Button>
      ),
    },
    {
      Header: "Reject",
      Cell: ({ cell }: any) => (
        <Button
          isDisabled={cell.row.original.isVerified !== "Pending"}
          bg="orangered"
          onClick={() => {
            setCurrentScript(cell.row.original);
            setIsApproved(false);
            onOpen();
          }}
        >
          <GiCancel />
        </Button>
      ),
    },
  ];
  const [allScripts, setAllScripts] = useState<any>([]);
  const onSuccess = (res) => {
    setAllScripts(res.data);
  };
  const { isLoading } = useQueryWrapper(QUERY_KEYS.ADMIN_SCRIPTS, scriptsRequest.SCRIPTS_ADMIN, {
    onSuccess,
  });

  const initalFilter = searchParams.get("curFilter") ?? "Pending";
  const initalPage = Number(searchParams.get("pageNo")) ?? 0;
  const initalSort = searchParams.get("sort") ?? "name";

  const [filterOpt, setFilterOpt] = useState<FilterType>(initalFilter as FilterType);
  const [filteredData, setfilteredData] = useState<ScriptType[]>([]);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState(initalSort);

  const [currentPage, setCurrentPage] = useState(initalPage || 0);
  const [postsPerPage, setPostsPerPage] = useState(10);

  const lastPostIndex = (currentPage + 1) * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentScripts = filteredData.slice(firstPostIndex, lastPostIndex);
  const pageCountCal = Math.ceil(filteredData.length / postsPerPage);
  const pageCount = pageCountCal < 1 ? 1 : pageCountCal;
  useEffect(() => {
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      setfilteredData(
        allScripts.filter(
          ({ name, composer }) =>
            name.toLowerCase().includes(searchLower) ||
            composer.toLowerCase().includes(searchLower),
        ),
      );
    } else {
      setfilteredData(allScripts);
    }
  }, [allScripts, searchText]);

  useEffect(() => {
    let currentFiltered = allScripts;
    switch (filterOpt) {
      case "All":
        // setfilteredData(allScripts);
        currentFiltered = allScripts;
        break;
      case "Published":
        // setfilteredData(allScripts.filter(({ isVerified }) => isVerified === "Published"));
        currentFiltered = allScripts.filter(({ isVerified }) => isVerified === "Published");

        break;
      case "Cancelled":
        // setfilteredData(allScripts.filter(({ isVerified }) => isVerified === "Cancelled"));
        currentFiltered = allScripts.filter(({ isVerified }) => isVerified === "Cancelled");
        break;
      default:
        // setfilteredData(allScripts.filter(({ isVerified }) => isVerified === "Pending"));
        currentFiltered = allScripts.filter(({ isVerified }) => isVerified === "Pending");

        break;
    }
    const sorted = currentFiltered.sort(sorter(sortBy));
    setfilteredData(sorted);
  }, [filterOpt, allScripts]);

  const sortTable = (selected) => {
    setSortBy(selected);
    const sorted = filteredData.sort(sorter(selected));
    setfilteredData(sorted);
    setSearchParam({ curFilter: filterOpt, pageNo: currentPage.toString(), sort: selected });
  };
  return (
    <>
      <Box
        mt="4"
        ml={{
          base: "0",
          md: "0",
          lg: "0",
          xl: "0",
        }}
      >
        <Text as="h1" fontSize="1.3rem" color="#4e6e97" mt="4" ml="4" textTransform="uppercase">
          Admin view all
        </Text>
        <Box p={"0 10px"} mt="2">
          <InputGroup mb={[8, 8, null]} w="100%">
            <InputLeftElement pointerEvents="none">
              <AiOutlineSearch color="gray.300" />
            </InputLeftElement>
            <Input
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              type="search"
              placeholder="Search your scripts"
            />
          </InputGroup>
        </Box>
        <Flex>
          <Box textAlign="right">
            <Menu>
              <MenuButton
                mx={2}
                as={Button}
                aria-label="Sort scripts"
                leftIcon={<BiFilter />}
                variant="outline"
                fontWeight="normal"
              >
                Sort: {sortBy}
              </MenuButton>
              <MenuList minWidth="240px" zIndex={14}>
                <MenuOptionGroup onChange={sortTable} defaultValue="name" title="Sort" type="radio">
                  <MenuItemOption value="name">Name</MenuItemOption>
                  <MenuItemOption value="composer">Composer</MenuItemOption>
                  <MenuItemOption value="user">Uploaded by</MenuItemOption>
                  <MenuItemOption value="createdAt">Uploaded On</MenuItemOption>
                </MenuOptionGroup>
              </MenuList>
            </Menu>
          </Box>

          <Box textAlign="right">
            <Menu>
              <MenuButton
                mx={2}
                as={Button}
                aria-label="Filter scripts"
                leftIcon={<BiFilter />}
                variant="outline"
                fontWeight="normal"
              >
                Filter: {filterOpt}
              </MenuButton>
              <MenuList minWidth="240px" zIndex={14}>
                <MenuOptionGroup
                  onChange={(selected: any) => {
                    setFilterOpt(selected);
                    setCurrentPage(0);
                    setSearchParam({ curFilter: selected, pageNo: "0", sort: sortBy });
                  }}
                  defaultValue="all"
                  title="Filter"
                  type="radio"
                >
                  <MenuItemOption value="All">All</MenuItemOption>
                  <MenuItemOption value="Pending">Pending</MenuItemOption>
                  <MenuItemOption value="Published">Published</MenuItemOption>
                  <MenuItemOption value="Cancelled">Cancelled</MenuItemOption>
                </MenuOptionGroup>
              </MenuList>
            </Menu>
          </Box>
        </Flex>
        <Box p="4">
          <TableContents
            data={currentScripts}
            columns={COLUMNS}
            loading={isLoading}
            startIndex={+postsPerPage * currentPage + 1}
          />
        </Box>
        <>
          <Paginator
            pageCount={pageCount}
            onPageChange={(page) => {
              setSearchParam({
                curFilter: filterOpt,
                pageNo: page.selected.toString(),
                sort: sortBy,
              });
              setCurrentPage(page.selected);
            }}
            pageNo={currentPage}
            pageSize={postsPerPage}
            onSizeChange={(selectedPage) => {
              setPostsPerPage(+selectedPage);
              setCurrentPage(0);
              setSearchParam({ curFilter: filterOpt, pageNo: "0", sort: sortBy });
            }}
          />
        </>
      </Box>
      <VerifyModal
        isOpen={isOpen}
        onClose={onClose}
        isApproved={isApproved}
        script={currentScript}
      />
      <ComposerModal
        isOpen={isOpenComposer}
        onClose={onCloseComposer}
        currentScript={currentScript}
      />
      <AddComposerModal
        isOpen={isOpenAddComposer}
        onClose={onCloseAddComposer}
        newComposer={newComposer}
      />
    </>
  );
};

export default VerificationPage;

const sorter = (key) => {
  if (key === "composer") {
    return function (a, b) {
      const first = a?.scriptComposer?.name;
      const second = b?.scriptComposer?.name;
      if (first === null && second === null) {
        return 0;
      }
      if (first === null) {
        return 1;
      }
      if (second === null) {
        return -1;
      }
      if (first < second) {
        return -1;
      }
      if (first > second) {
        return 1;
      }
      return 0;
    };
  }

  if (key === "user") {
    return function (a, b) {
      const first = a?.user?.userName;
      const second = b?.user?.userName;
      if (first < second) {
        return -1;
      }
      if (first > second) {
        return 1;
      }
      return 0;
    };
  }
  return function (a, b) {
    const isCreatedAt = key === "createdAt";
    if (a[key] < b[key]) {
      return isCreatedAt ? 1 : -1;
    }
    if (a[key] > b[key]) {
      return isCreatedAt ? -1 : 1;
    }
    return 0;
  };
};

async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    successToast("Copied!!");
  } catch (err) {
    errorToast("Failed to copy text: ");
  }
}
